
import { defineComponent, computed } from 'vue'

import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'ButtonGradient',

  setup() {
    const { currentTheme, currentMode } = useTheme()

    const buttonClasses = computed(() => {
      const {
        from,
        to,
        direction,
        text,
        hoverFrom,
        hoverTo,
      } = currentTheme.value.gradients.button

      return [direction, from, to, hoverFrom, hoverTo, text]
    })

    return {
      currentMode,
      currentTheme,
      buttonClasses,
    }
  },
})
